import { AUTH_HEADERS, baseUrl, DrillFile, Package, PackageFile, Portal } from './typings';
import { ApiContextType } from './api-context';

export const fetchPackage = (api: ApiContextType, id: number): Promise<Package> => {
    return api.get(`/article/${id}`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const updatePackage = (api: ApiContextType, id: string, filePackage: Package) => {
    return api.post(`/article/${id}`, filePackage)
        .then((res) => {
            if (res.status !== 200 && res.status !== 204) {
                return Promise.reject();
            }
            return Promise.resolve();
        });
}

export const clonePackage = (api: ApiContextType, id: number, organisationId: number): Promise<string> => {
    return api.put(`/article/${id}/clone/${organisationId}`)
        .then((res) => {
            if (res.status !== 200 && res.status !== 204) {
                return Promise.reject();
            }
            return res.text();
        });
}

export const deletePackage = (api: ApiContextType, id: string) => {
    return api.del(`/article/${id}`)
        .then((res) => {
            if (res.status !== 200 && res.status !== 204) {
                return Promise.reject();
            }
            return Promise.resolve();
        });
}

export const afterUploadThumbnail = (api: ApiContextType, id: string) => {
    return api.post(`/article/${id}/upload/thumbnail`);
}

export const afterUploadPreview = (api: ApiContextType, id: string, name: string) => {
    return api.post(`/article/${id}/upload/preview/${name}`);
}

export const deletePreview = (api: ApiContextType, id: string, name: string) => {
    return api.del(`/article/${id}/image/${name}`);
}

export const fetchPortals = (api: ApiContextType): Promise<Portal[]> => {
    return api.get(`/portals`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const fetchFiles = (api: ApiContextType, id: number): Promise<PackageFile[]> => {
    return api.get(`/drills/${id}`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};
